import React, { Component } from 'react';
import { withStyles } from 'material-ui/styles';
import { FusePageSimple } from '@fuse';
import { Tab, Tabs } from 'material-ui';
import $ from "jquery";

import Tab1GeneralDetails from './components/Tab1GeneralDetails';
import Tab2EducationQualification from './components/Tab2EducationQualification';
import Tab3ProfesionalQualification from './components/Tab3ProfesionalQualification';
import Tab1Department from '../systemSetting/components/Tab1Department';
import Tab2Desingnation from '../systemSetting/components/Tab2Desingnation';
// import DownshiftMultiple from './extenalComponents/DownshiftMultiple';

const styles = theme => ({
    layoutRoot: {},
    layoutToolbar: {
        padding: 0
    },
    tabsRoot: {
        height: 64
    },
    tabRoot: {
        height: 64
    },
    root: {
        width: '100%',
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        flexBasis: '33.33%',
        flexShrink: 0,
    },
    secondaryHeading: {
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary,
    }
});

class CreateNewEmployee extends Component {

    state = {
        value: 0,
        nic: null,
        emp_profile_id: null,
        emp_registry_id: null
    };

    handleChangeT = (event, value) => {

        this.setState({ value });
        event.preventDefault();
    };

    handleNicPass = (nic, emp_profile_id, emp_registry_id) => {
        // alert(emp_profile_id)
        this.setState({
            nic: nic,
            emp_profile_id: emp_profile_id,
            emp_registry_id: emp_registry_id

        });
    }


    fixedImgIntoDiv(input) {
        if (input.files && input.files[0]) {
            var reader = new FileReader();

            reader.onload = function (e) {
                $('#profileImg').attr('src', e.target.result);
            };

            reader.readAsDataURL(input.files[0]);
        }
    }


    render() {

        const { value } = this.state;
        const { classes } = this.props;

        return (

            <FusePageSimple
                classes={{
                    root: classes.layoutRoot,
                    toolbar: classes.layoutToolbar
                }}
                // header={
                //     <div className="p-24"><h4>Employee Registation</h4></div>
                // }
                contentToolbar={
                    <Tabs
                        value={value}
                        onChange={this.handleChangeT}
                        indicatorColor="primary"
                        textColor="primary"
                        scrollable
                        scrollButtons="auto"
                        classes={{
                            root: classes.tabsRoot
                        }}
                    >
                        <Tab
                            classes={{
                                root: classes.tabRoot
                            }}
                            label="General Details"
                        />

                        <Tab
                            classes={{
                                root: classes.tabRoot
                            }}
                            label="Education Qualification"
                        />

                        <Tab
                            classes={{
                                root: classes.tabRoot
                            }}
                            label="Professional Qualification"
                        />

                    </Tabs>
                }
                content={
                    <div className="px-24">


                        {value === 0 &&
                            (
                                <Tab1GeneralDetails />

                            )}

                        {value === 1 && (
                            <Tab2EducationQualification nicpasser={this.handleNicPass} />
                        )}

                        {value === 2 && (
                            <Tab3ProfesionalQualification nic={this.state.nic}
                                emp_profile_id={this.state.emp_profile_id}
                                emp_registry_id={this.state.emp_registry_id} />
                        )}


                    </div>
                }
            />
        )
    };
}



export default withStyles(styles, { withTheme: true })(CreateNewEmployee);


// WEBPACK FOOTER //
// ./src/main/content/hr/createEmployee/CreateNewEmployee.js